// import {Timeline, TimelineEvent} from "react-event-timeline";
import {FaCircle} from "react-icons/fa";
import {ReactNode} from "react";

interface PropsI {
    children: ReactNode[];
    isHorizontal?: boolean;
    timelineStep: number;
}

const BaseTimeline = ({ children, timelineStep }: PropsI) => {
    return (null
        // <Timeline
        //     style={{padding: 0}}
        //     lineColor={"#00AB09"}
        //     lineStyle={{left: 12}}
        // >
        //     { children.map((childNode, index)=>(
        //         <TimelineEvent
        //             key={index}
        //             title={childNode}
        //             icon={<FaCircle className="hw-12" />}
        //             bubbleStyle={{height: 24, width: 24, color: timelineStep > index ? '#A0BDA2' : '#00AB09' }}
        //         />
        //     ))}
        // </Timeline>
    )
}

export default BaseTimeline;